/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "../services/axios/backendAxios";
import { useCallback } from "react";
import { tokenSupplier } from "../services/axios/webAuth";

const createInput = (name: string, value: any, type = "text") => {
  const input = document.createElement("input");
  input.type = type || "text";
  input.name = name;
  input.value = value;
  return input;
};

export const buildDownloadFormEntries = (
  data: Record<string, any>,
): Array<{ name: string; value: any }> => {
  const entries: Array<{ name: string; value: any }> = [];
  for (const key in data) {
    const value = data[key];
    if (Array.isArray(value)) {
      for (const item of value) {
        entries.push({ name: key, value: item });
      }
    } else if (value !== undefined && value !== null) {
      entries.push({ name: key, value });
    }
  }
  return entries;
};

const useDownloadHelper = (action: string) => {
  const download = useCallback(
    async (data: Record<string, any>) => {
      const token = await tokenSupplier.getToken();
      // Create a hidden form element
      const form = document.createElement("form");
      form.style.display = "none"; // Hide the form

      // Collects a fresh token

      // Set form attributes
      form.method = "POST";
      form.action = axios.defaults.baseURL?.replace(/\/+$/, "") + action;
      console.log(form.action, axios.defaults.baseURL);
      form.target = "_blank"; // Open response in a new tab

      const entries = buildDownloadFormEntries(data);
      for (const entry of entries) {
        form.appendChild(createInput(entry.name, entry.value));
      }

      form.appendChild(createInput("authToken", token, "hidden"));
      // Append the form to the document body
      document.body.appendChild(form);
      // Submit the form
      form.submit();
    },
    [action],
  );

  return download;
};

export default useDownloadHelper;
